<div class="main">
  <div class="device-logo web-logo">
    <app-logo></app-logo>
  </div>
  <div class="custom-wrapper">
    <div id="header_section" class="header-section d-flex">
      <div id="back_icon_mob">
        @if (reasonForLeaving || deleteAccountConfirm) {
          <img (click)="goBack()" pointer imageName="accent-back-arrow.svg" alt="Back" />
        }
      </div>
      <div class="mt-2"><app-logo></app-logo></div>
    </div>
    <section class="login-content">
      <div class="signup-header">
        @if (reasonForLeaving || deleteAccountConfirm) {
          <div id="back_icon_web">
            <img (click)="goBack()" pointer imageName="accent-back-arrow.svg" alt="Back" />
          </div>
        }
        <h2 id="main_header_text" class="login-main-header mb-0">Account Deletion</h2>
      </div>
      @if (isDeleteFlow) {
        <div>
          @if (basicInfo) {
            <ul>
              <li>
                We're sorry to see you go, but we understand that circumstances may change. Before
                you proceed with account deletion, we want to ensure you are aware of the
                implications and alternatives.
              </li>
              <li>
                Deleting your account means you will lose access to your prescription history,
                health records, and personalized features. If you're facing issues or have concerns,
                our support team is here to assist you. Please reach out to
                @if (cmsService.getTechnicalSupportNumber() | async; as supportNumber) {
                  <a [href]="`tel:${supportNumber}`">{{ supportNumber }}</a>
                }
                before making this decision.
              </li>
            </ul>
          }
          <div class="login-content-wrapper">
            <form [formGroup]="deleteAccountForm">
              <div class="form-content">
                @if (basicInfo) {
                  <div class="form-group">
                    <label for="username">
                      Username
                      <span class="input-required-on-dark-bg text-w-600">*</span>
                    </label>
                    <input
                      id="username"
                      formControlName="userName"
                      type="text"
                      name="Username"
                      class="form-control"
                    />
                    @if (
                      deleteAccountForm.get('userName')?.errors?.required &&
                      deleteAccountForm.get('userName')?.touched
                    ) {
                      <span class="text-danger">Please enter valid username</span>
                    }
                  </div>
                }
                @if (basicInfo) {
                  <div class="form-group">
                    <label for="email">
                      Registered Email
                      <span class="input-required-on-dark-bg text-w-600">*</span>
                    </label>
                    <input
                      id="email"
                      formControlName="email"
                      (keyup)="checkEmailUpdateEvent($event)"
                      type="email"
                      name="Registered Email"
                      class="form-control"
                    />
                    @if (
                      deleteAccountForm.get('email')?.errors?.required &&
                      deleteAccountForm.get('email')?.touched
                    ) {
                      <span class="text-danger">Please enter valid email address</span>
                    }
                  </div>
                }
                @if (basicInfo && isVerificationCode) {
                  <div class="form-group">
                    <label for="verificationcode">
                      Verification Code
                      <span class="input-required-on-dark-bg text-w-600">*</span>
                    </label>
                    <input
                      id="verificationcode"
                      formControlName="verificationCode"
                      maxlength="6"
                      type="text"
                      (keypress)="checkIfSpace($event)"
                      name="Verification Code"
                      class="form-control"
                    />
                    @if (
                      deleteAccountForm.get('verificationCode')?.errors?.required &&
                      deleteAccountForm.get('verificationCode')?.touched
                    ) {
                      <span class="text-danger">Please enter valid verification code</span>
                    }
                    <span class="text-info">Check your email for a 6-digit verification code</span>
                  </div>
                }
                @if (reasonForLeaving) {
                  <div class="form-group full-width">
                    <label for="reasonforleaving">
                      Reason for Leaving
                      <span class="input-required-on-dark-bg text-w-600">*</span>
                    </label>
                    <mat-form-field appearance="fill" class="select-year select-reason">
                      <mat-select
                        formControlName="leavingReason"
                        name="reason"
                        (selectionChange)="selectReason($event.value)"
                      >
                        <mat-option value="">Select Reason for Leaving</mat-option>
                        <mat-option value="No longer required">No longer required</mat-option>
                        <mat-option value="Data privacy concern">Data privacy concern</mat-option>
                        <mat-option value="other">Other</mat-option>
                      </mat-select>
                    </mat-form-field>
                    @if (
                      deleteAccountForm.get('leavingReason')?.errors?.required &&
                      deleteAccountForm.get('leavingReason')?.touched
                    ) {
                      <span class="text-danger">Please enter valid reason</span>
                    }
                  </div>
                }
                @if (reasonForLeaving) {
                  <div class="form-group">
                    <label for="additionalcomments">Additional Comments</label>
                    <textarea
                      formControlName="additionComment"
                      name="additionalcomments"
                      class="form-control"
                      rows="6"
                    ></textarea>
                    @if (
                      deleteAccountForm.get('additionComment')?.errors?.required &&
                      deleteAccountForm.get('additionComment')?.touched
                    ) {
                      <span class="text-danger">Please enter additional comment</span>
                    }
                  </div>
                }
              </div>
              @if (deleteAccountConfirm) {
                <div class="form-group">
                  <label for="dateofbirth">
                    Date of Birth (MM/DD/YYYY)
                    <span class="input-required-on-dark-bg text-w-600">*</span>
                  </label>
                  <mat-form-field appearance="fill" class="dob-datepicker">
                    <input
                      matInput
                      formControlName="DOB"
                      [max]="maxDate"
                      [matDatepicker]="picker"
                    />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  @if (
                    deleteAccountForm.get('DOB')?.errors?.required &&
                    deleteAccountForm.get('DOB')?.touched
                  ) {
                    <span class="text-danger">Please enter valid date of birth</span>
                  }
                </div>
              }
              <div class="buttons">
                @if (basicInfoWithoutVerification) {
                  <button
                    mat-raised-button
                    type="submit"
                    class="primary-button uppercase"
                    [disabled]="
                      deleteAccountForm.get('userName')?.invalid ||
                      deleteAccountForm.get('email')?.invalid
                    "
                    (click)="sendVerificationCode()"
                  >
                    Send Verification Code
                  </button>
                }
                @if (isVerificationCode) {
                  <button
                    mat-raised-button
                    type="button"
                    class="primary-button uppercase action-button"
                    [disabled]="
                      (deleteAccountForm.get('userName')?.invalid &&
                        deleteAccountForm.get('email')?.invalid) ||
                      deleteAccountForm.get('verificationCode')?.invalid
                    "
                    (click)="verify()"
                  >
                    Verify
                  </button>
                }
                @if (isVerificationCode) {
                  <button
                    mat-raised-button
                    type="button"
                    class="secondary-button uppercase action-button"
                    (click)="resend()"
                  >
                    Resend
                  </button>
                }
                @if (reasonForLeaving) {
                  <button
                    mat-raised-button
                    type="button"
                    class="primary-button uppercase"
                    [disabled]="
                      deleteAccountForm.get('leavingReason')?.invalid ||
                      deleteAccountForm.get('additionComment')?.invalid
                    "
                    (click)="next()"
                  >
                    Next
                  </button>
                }
                @if (deleteAccountConfirm) {
                  <button
                    mat-raised-button
                    type="button"
                    class="primary-button uppercase"
                    [disabled]="deleteAccountForm.get('DOB')?.invalid"
                    (click)="deleteAccount()"
                  >
                    Delete My Account
                  </button>
                }
              </div>
            </form>
          </div>
        </div>
      } @else {
        <div class="acknowledge-content">
          <h3>Acknowledgment</h3>
          <p>Your {{ appName }} Application account has been successfully deleted.</p>
          <p>
            Should you have any further inquiries or require additional assistance, please do not
            hesitate to contact our customer support team
            @if (cmsService.getTechnicalSupportNumber() | async; as supportNumber) {
              <a [href]="`tel:${supportNumber}`">
                {{ supportNumber }}
              </a>
            }
          </p>
        </div>
      }
      <ng-template #acknowledge>
        <div class="acknowledge-content">
          <h3>Acknowledgment</h3>
          <p>Your {{ appName }} Application account has been successfully deleted.</p>
          <p>
            Should you have any further inquiries or require additional assistance, please do not
            hesitate to contact our customer support team
            @if (cmsService.getTechnicalSupportNumber() | async; as supportNumber) {
              <a [href]="`tel:${supportNumber}`">
                {{ supportNumber }}
              </a>
            }
          </p>
        </div>
      </ng-template>
      <div class="footer-section d-flex justify-content-between">
        @if (cmsService.getTechnicalSupportNumber() | async; as supportNumber) {
          <div class="help-number">
            <span>Technical Support </span>
            <a [href]="`tel:${supportNumber}`">{{ supportNumber }}</a>
          </div>
        }
      </div>
    </section>
  </div>
</div>
<ng-template #errors>
  <div class="toaster-bg error d-flex justify-content-center">
    <mat-icon class="icon-error mr-1"></mat-icon>
    <span>{{ errorMsg }}</span>
  </div>
</ng-template>
<ng-template #success>
  <div class="toaster-bg success d-flex justify-content-center">
    <mat-icon class="icon-success mr-1"></mat-icon>
    <span>{{ successMsg }}</span>
  </div>
</ng-template>
